import { useQuery } from "@tanstack/react-query";
import type { DevSnapshotOption } from "@rrid/shared-types";
import { api } from "../lib/api.js";

interface DevSnapshotsResponse {
  active: string | null;
  snapshots: DevSnapshotOption[];
}

/** Snapshots available for runtime dev login (AUTH_MODE=dev). */
export function useDevSnapshots(opts: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["dev-snapshots"],
    queryFn: async () => {
      try {
        return await api.get<DevSnapshotsResponse>("/auth/dev-snapshots");
      } catch {
        return { active: null, snapshots: [] } satisfies DevSnapshotsResponse;
      }
    },
    enabled: opts.enabled ?? true,
    retry: false,
    staleTime: 60_000,
  });
}
